import React, { useState, useEffect } from 'react'
import { GET_CUSTOMER_LIST, GET_STATES } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import Select from 'react-select';
import { GST_TYPES } from '../../../data/constant';
import { useTranslation } from 'react-i18next';
import CustomerModal from '../../modals/CustomerModal';

export default function SelectCustomer({ remitCustomer, customerId }) {

     const [selectedOption, setCustomerSelectedOption] = useState(null);
     const [stateSelectedOption, setStateSelectedOption] = useState(null);
     const [customerList, setCustomerList] = useState([]);
     const [customerOption, setcustomerOption] = useState([]);
     const [states, setStates] = useState([]);
     const [customer, setCustomer] = useState({});
     const { t } = useTranslation();
     const [customerModal, setCustomerModal] = useState(false);
     const [loading, setLoading] = useState(false);

     useEffect(() => {
          getcustomerList();
          getState();
          setCustomerFromProps();
     }, [])

     useEffect(() => {
          remitData();
     }, [selectedOption, stateSelectedOption])

     useEffect(() => {
          setCustomerFromProps();
     }, [customerId])

     const setCustomerFromProps = () => {
          if (customerId && customerList) {
               const foundcustomer = customerList.find(element => element.customer_id === customerId);
               if (foundcustomer) {
                    setCustomerSelectedOption({ label: `${foundcustomer.full_name} [${foundcustomer.mobile}]`, value: foundcustomer.customer_id });
               }
               findcustomer(customerId);
          }
     }

     const getcustomerList = async (input = '') => {
          setLoading(true);
          let payload = { customerType: 0, string: input }
          const res = await httpClient.sendRequest(GET_CUSTOMER_LIST, payload);
          setLoading(false);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    setCustomerList(data);
                    let option = [];
                    data.forEach(element => {
                         option.push({ label: `${element.full_name} [${element.mobile}]`, value: element.customer_id });
                    });
                    setcustomerOption(option);
               }
          }
     }

     const handleInputChange = (inputValue, { action }) => {
          if (action === 'input-change') {
               getcustomerList(inputValue);
          }
     };

     const onCustomerChange = (selectedOption) => {
          setCustomerSelectedOption(selectedOption);
          findcustomer(selectedOption.value);
     };

     const onStateChange = (selectedOption) => {
          setStateSelectedOption(selectedOption);
          setCustomer(preCustomer => ({
               ...preCustomer,
               state: selectedOption.value
          }));
     };

     const findcustomer = (customer_id) => {
          const foundcustomer = customerList.find(element => element.customer_id === customer_id);
          if (foundcustomer) {
               setCustomer(foundcustomer);
               const state = states.find(element => element.value === foundcustomer.state);
               if (state) {
                    setStateSelectedOption(state);
               } else {
                    setStateSelectedOption(null);
               }
          }
     };

     const getState = async (e) => {
          const res = await httpClient.post(GET_STATES, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let options = [];
                    result.data.forEach((row, index) => {
                         options.push({ label: row.name, value: row.id });
                    });
                    setStates(options);
               }
          }
     }

     const customerModalAction = (status = false) => {
          setCustomerModal(status);
          getcustomerList();
     }

     const remitData = () => {
          if (selectedOption) {
               let s = stateSelectedOption ? stateSelectedOption.value : null;
               const data = { customer: customer, customer_id: selectedOption.value, state_id: s }
               remitCustomer(data);
          }
     }

     return (
          <div className='p-1 bg-light'>
               <div className='row'>
                    <div className='col-md-6'>
                         <label className='mb-0'>{t('select_customer')}</label> <button style={{ cursor: "pointer" }} className='btn btn-sm btn-outline-primary btn-fw' onClick={(e) => customerModalAction(true)}>+</button>
                         <Select
                              autoFocus
                              id='customer_id'
                              value={selectedOption}
                              options={customerOption}
                              isSearchable={true}
                              placeholder="Select"
                              onChange={onCustomerChange}
                              onInputChange={handleInputChange}
                              isLoading={loading}
                         />
                         {Object.keys(customer).length > 0 && <small>{t('gst_number')} : {customer.gst_number} <br />{t('type')} : {GST_TYPES[customer.gst_type]}</small>}
                    </div>
                    {Object.keys(customer).length > 0 &&
                         <div className='col-md-6'>
                              <label className='mb-0'>{t('play_of_supply')} : </label>
                              <Select
                                   id='play_of_supply'
                                   value={stateSelectedOption}
                                   options={states}
                                   isSearchable={true}
                                   placeholder="Select"
                                   onChange={onStateChange}
                              />
                              <label className='mb-0' htmlFor='billing_address'><small>{t('billing_address')} :
                                   {t('address')} : {customer.address},{t('city')} : {customer.city}, {t('pincode')} : {customer.pincode}</small>
                              </label>
                         </div>
                    }
                    <CustomerModal show={customerModal} handleClose={customerModalAction} />
               </div>
          </div>
     )
}
